import { useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();
  const allowedPaths = ["/top", "/", "/prediction-market"];
  const shouldShowFooter = allowedPaths.includes(location.pathname);

  if (!shouldShowFooter) return null;

  return (
    <footer className="w-full flex justify-center items-center bg-black text-white py-8">
      <div className="flex flex-col items-center w-full max-w-[600px] xl:w-full">
        <img src="/assets/logo-white.svg" alt="Main Content Background" className="w-[30%] max-w-[300px]" />
        <p className="text-disabled text-xs py-2">© Masentic Inc.</p>
        <div className="flex justify-center gap-2 py-6">
          <a href="https://x.com/ThumbaJP" target="_blank" rel="noopener noreferrer">
            <img src="/assets/icon-x-white.svg" alt="Main Content Background" className="w-8 h-8" />
          </a>
          <a href="https://lin.ee/4f3IfmZ" target="_blank" rel="noopener noreferrer">
            <img src="/assets/line.svg" alt="Main Content Background" className="w-8 h-8" />
          </a>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mt-2 text-center">
          <a href="/terms-of-service" rel="noopener noreferrer" className="text-white text-xs sm:text-sm">
            利用規約
          </a>
          <span className="sm:inline">|</span>
          <a href="/privacy-policy" rel="noopener noreferrer" className="text-white text-xs sm:text-sm">
            プライバシーポリシー
          </a>
          <span>|</span>

          <a
            href="https://lin.ee/wk85Btz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-xs sm:text-sm"
          >
            お問い合わせ
          </a>
          <span>|</span>
          <a
            href="https://masentic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-xs sm:text-sm"
          >
            運営会社
          </a>
        </div>
      </div>
    </footer>
  );
};
